import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    TextButton,
    Spacer,
    Label,
    Input,
    Text,
    Button,
} from '@zillow/constellation';
import { Col, Row, HR } from '@zillow/zrs-comet';

import emailUtils from 'app/shared/utils/emailUtils';
import UserManagementActions from 'app/shared/actions/UserManagementActions';

const SUPPORT_EMAIL_MSG = 'Please contact rentalpartners@zillowgroup.com to have this person added to your company.';

import './style.scss';

const propTypes = {
    currentUser: PropTypes.object.isRequired,
};

const AddUserStepOne = ({
    currentUser,
    onNextStep,
    onCancel,
    dispatch,
}) => {
    const [isVerifyingEmail, setIsVerifyingEmail] = React.useState(false);
    const [errors, setErrors] = React.useState({});

    const handleValidateEmail = () => {
        if (!emailUtils.isValid(currentUser.email)) {
            setErrors({
                ...errors,
                email: 'Please, enter a valid email address',
            });
            return;
        }
        setIsVerifyingEmail(true);
        setErrors({
            ...errors,
            email: 'Verifying...',
        });
        dispatch(UserManagementActions.verifyEmail(currentUser.email))
            .then(() => {
                setIsVerifyingEmail(false);
                setErrors({
                    ...errors,
                    email: null,
                });
            }).catch((err) => {
                setIsVerifyingEmail(false);
                const message = err.message.toLowerCase().includes('email')
                    ? err.message
                    : `${err.message} ${SUPPORT_EMAIL_MSG}`;
                setErrors({
                    ...errors,
                    email: message,
                });
            });
    };

    React.useEffect(() => {
        if (currentUser.email) {
            handleValidateEmail();
        }
    }, []);

    return (
        <div>
            <Spacer marginY="sm">
                <Text>Enter basic information</Text>
            </Spacer>
            <Row>
                <Col md={4}>
                    <Label>Email:</Label>
                    <Input
                        type="text"
                        value={currentUser.email}
                        onChange={e => dispatch(UserManagementActions.currentUserSetEmail(e.target.value.trim()))}
                        onBlur={handleValidateEmail}
                        error={errors.email}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <Spacer marginY="sm">
                        <Label>Name:</Label>
                        <Input
                            value={currentUser.userName}
                            onChange={e => dispatch(UserManagementActions.currentUserSetName(e.target.value))}
                            error={errors.userName}
                        />
                    </Spacer>
                </Col>
            </Row>
            <HR />
            <div className="Questions-footer">
                <TextButton className="Questions-button" onClick={onCancel}>
                    Cancel
                </TextButton>
                <Button
                    buttonType="primary"
                    onClick={onNextStep}
                    disabled={Boolean(isVerifyingEmail
                        || errors.email || !currentUser.email || !currentUser.userName)}
                >
                    Continue
                </Button>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    currentUser: state.userManagement.currentUser,
});

AddUserStepOne.propTypes = propTypes;

export default connect(mapStateToProps)(AddUserStepOne);
